import ApiRequest from '../../utils/ApiRequest';
import { EnrollmentPackageId } from "../../types/api/primaryKeys/PrimaryKey";
import { PlanRateRequest } from "../../types/api/rates/PlanRateRequest";
import { PlanRateResponse } from '../../types/api/rates/PlanRateResponse';



export async function getPlanRates(packageId: EnrollmentPackageId, plans: readonly PlanRateRequest[]) {
    const result = await ApiRequest.post<readonly PlanRateResponse[]>(`packages/${packageId}/packageplanrates`, plans);
    return result;
}